<!-- 绑定手机组件 -->
<template id="bind_phone">
  <section class="bind-phone">
    <form class="s-form">
      <div class="s-form-row">
        <label class="s-form-label">我的手机号：</label>
        <div class="s-form-info">
          <select class="" name="">
            <option value="">中国+86</option>
          </select>
          <input type="phone" name="" v-model="phoneNumber" @input="validatePhone">
        </div>
      </div>
      <send_code :type="v_type" :request="request" :is_new="'true'" @errorResult="errorResult"></send_code>
      <div class="s-form-btnrow">
        <button type="button" class="s-button submit s-btn-success" name="button" @click="next">提交</button>
      </div>
    </form>
    <v-alert :options="options"></v-alert>
  </section>
</template>

<script>
  import send_code from './../send_code.vue';
  import vAlert from '../../alert.vue'; 
  export default {
    data() {
      return {
        v_phone: this.$root.config.validatePhone,
        v_type: 'phone',
        phoneNumber: '',
        phoneError: false,
        options: {
            // 消息弹窗
            msgText: '',
            msgIsSuccess: true
        },
      }
    },
    computed: {
        request() {
            return {
            phone: this.phoneNumber,
            // hasError: false
            }
        },
        phoneValue () {
            return this.$store.state.verificaPhone;
        }
        
    },
    methods: {
      /*
       ** 验证手机号
       */
      validatePhone() {
        // this.phoneError = !this.v_phone(this.phoneNumber);
      },
      /*
       ** 下一步
       */
      next() {
            // let phoneError = this.validatePhone(),
            let reg = /^1[3|4|5|7|8|9][0-9]{9}$/;
            this.phoneError = reg.test(this.phoneNumber); // 验证手机号
            let codeError = this.$children[0].validateCode();  // 为false才会走
            console.log(this.phoneValue)
            if(this.phoneError && !codeError){
                let req = {
                    phone: this.phoneNumber,
                    code: this.$children[0].code,
                    precode: this.phoneValue.precode,
                    pretype: this.phoneValue.pretype
                };

                axios.post(myUrl + 'profile/update/phone/', qs.stringify(req)).then(response => {
                    let res = response.data;

                    if(res.code == 0 && res.result){
                        this.$parent.$parent.$parent.statusList[1].value = res.data;
                        this.$emit('next');
                    }
                    else{
                        console.log(res.message);
                        this.options = {
                            msgText: res.message,
                            msgIsSuccess: false
                        };
                    }
                }, reject => {
                    console.log(reject);
                });
            }
      },
      errorResult(response) {
        this.$emit('errorResult', response);
      }
    },
    components: {
      send_code,
      vAlert
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .s-form{
    &-subtext{
      margin-top: 15px;
    }
    .submit{
      width: 100px;
      margin-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// bind_phone.vue?0f2fa0ea